import React, { useState } from "react";
import { Col, Row, Card, Form, Button, ButtonGroup } from '@themesberg/react-bootstrap';

export default () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "Kadın",
    birthDate: "",
    email: "",
    password: "",
    description: "",
    profileImage: "file",
    galleryImages: "file"
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form data:", formData);
  };

  return (
    <>
      <div className="py-4">
        <h4>Ekle</h4>
        <p className="text-muted mb-0">Üyeler / Ekle</p>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          <h5 className="mb-4">Üye Bilgileri</h5>

          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Tam İsim <span className="text-danger">*</span>
                  </Form.Label>
                  <Row>
                    <Col>
                      <Form.Control
                        type="text"
                        name="firstName"
                        placeholder="İsim"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </Col>
                    <Col>
                      <Form.Control
                        type="text"
                        name="lastName"
                        placeholder="Soyisim"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Cinsiyet <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="Kadın">Kadın</option>
                    <option value="Erkek">Erkek</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Doğum Tarihi <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="birthDate"
                    placeholder="gg.aa.yyyy"
                    value={formData.birthDate}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Email <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="admin@gizliflort.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Şifre <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder="••••••"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Açıklama</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="description"
                    placeholder="Açıklama"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <h5 className="mb-3">Profil Resmi</h5>
            <Row className="mb-3">
              <Col md={12}>
                <ButtonGroup className="mb-2">
                  <Button
                    variant={formData.profileImage === "file" ? "primary" : "outline-secondary"}
                    size="sm"
                    onClick={() => setFormData(prev => ({ ...prev, profileImage: "file" }))}
                  >
                    Dosya Seç
                  </Button>
                  <Button
                    variant={formData.profileImage === "none" ? "primary" : "outline-secondary"}
                    size="sm"
                    onClick={() => setFormData(prev => ({ ...prev, profileImage: "none" }))}
                  >
                    Dosya seçilmedi
                  </Button>
                </ButtonGroup>
                {formData.profileImage === "file" && (
                  <Form.Control type="file" size="sm" className="mt-2" />
                )}
              </Col>
            </Row>

            <h5 className="mb-3">Galeri Resimleri</h5>
            <Row className="mb-4">
              <Col md={12}>
                <ButtonGroup className="mb-2">
                  <Button
                    variant={formData.galleryImages === "file" ? "primary" : "outline-secondary"}
                    size="sm"
                    onClick={() => setFormData(prev => ({ ...prev, galleryImages: "file" }))}
                  >
                    Dosyaları Seç
                  </Button>
                  <Button
                    variant={formData.galleryImages === "none" ? "primary" : "outline-secondary"}
                    size="sm"
                    onClick={() => setFormData(prev => ({ ...prev, galleryImages: "none" }))}
                  >
                    Dosya seçilmedi
                  </Button>
                </ButtonGroup>
                {formData.galleryImages === "file" && (
                  <Form.Control type="file" size="sm" className="mt-2" multiple />
                )}
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button variant="primary" type="submit" size="lg">
                Ekle
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
